import { useProductName } from '../hooks/useProductName';

const ProductReference = () => {
	const { blockClass } = useProductName();

	return (
		<span
			className={`productReference productReference--${blockClass} vtex-store-components-3-x-productReference vtex-store-components-3-x-productReference--${blockClass}`}
		>
			REF: 123456
		</span>
	);
};

export default ProductReference;
